import TabHeader from "../../tab/TabHeader"
import NotesComponent from "../notes/NotesComponent"
import SurgicalDetails from "./SurgicalDetails"

export default function SurgicalTab({ inWorkQ }) {

    return <>
        <TabHeader>
            <div className="flex-container">
                <h2>ASC</h2>
                <NotesComponent noteTypeId={17} inWorkQ={inWorkQ}/>
            </div>
        </TabHeader>
        <div>
            <SurgicalDetails />
        </div>
    </>
}